var map = {
	"./beastBonesCover.webp": 27924,
	"./castleCover.webp": 71282,
	"./dragonBattleCover.webp": 33049,
	"./dragonCastleCover.webp": 44403,
	"./dragonFlightCover.webp": 24301,
	"./fantasyLogin1.webp": 75259,
	"./overlookHeroCover.webp": 90437,
	"./wizardTreetopsCover.webp": 50495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60812;